import { render, staticRenderFns } from "./SelectSave.vue?vue&type=template&id=67fb6552&scoped=true"
import script from "./SelectSave.vue?vue&type=script&lang=js"
export * from "./SelectSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb6552",
  null
  
)

export default component.exports